<template>
    <div class="mySelect" v-if="!isShowText">
        <el-select v-model="province" placeholder="请选择" @change="setValue($event,1)">
            <el-option
                    v-for="item in provinceList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id">
            </el-option>
        </el-select>
        <el-select v-model="city" placeholder="请选择" @change="setValue($event,2)" :disabled="province==''">
            <el-option
                    v-for="item in cityList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id">
            </el-option>
        </el-select>
        <el-select v-model="district" placeholder="请选择" @change="setValue($event,3)" :disabled="city==''">
            <el-option
                    v-for="item in districtList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id">
            </el-option>
        </el-select>
    </div>
    <div v-else>
        {{regionText}}
    </div>
</template>
<script>
    export default {
        props:['lcy','text'],
        data() {
            return {
                province:'',
                provinceTpye:false,
                provinceList:[],
                city:'',
                cityTpye:false,
                cityList:[],
                district:'',
                districtTpye:false,
                districtList:[],
                id:this.lcy,
                isShowText:this.text==true?true:false,
                regionText:''
            };
        },
        methods: {
            getAdd(id){
                if(id==null || id==undefined)id='';
                this.$httpReq.get('/tree/regiontree?id='+id).then((data)=>{
                    console.log('2232323',data)
                    if(data.data!=''){
                        if(this.provinceList.length==0){
                            this.provinceList=data.data[0].children;
                            if(this.id!=''&&this.id!=null&&this.id!=undefined){
                                for(let x=0;x< data.data[0].children.length;x++){
                                    if(data.data[0].children[x].id==this.id.substring(0,2)+'0000'){
                                        this.province=data.data[0].children[x].text
                                        this.regionText+=data.data[0].children[x].text+'-'
                                    }
                                }
                                this.getAdd(this.id.substring(0,2)+'0000')
                            }
                            return;
                        }
                        if(this.cityList.length==0){
                            this.cityList=data.data[0].children;
                            if(this.id.substring(4,6)!='00'){
                                for(let x=0;x< data.data[0].children.length;x++){
                                    if(data.data[0].children[x].id==this.id.substring(0,4)+'00'){
                                        this.city=data.data[0].children[x].text
                                        this.regionText+=data.data[0].children[x].text+'-'
                                    }
                                }
                                this.getAdd(this.id.substring(0,4)+'00')
                            }
                            return;
                        }
                        if(this.districtList.length==0){
                            this.districtList=data.data[0].children
                            if(this.id.substring(4,6)!='00'){
                                for(let x=0;x< data.data[0].children.length;x++){
                                    if(data.data[0].children[x].id==this.id){
                                        this.district=data.data[0].children[x].text
                                        this.regionText+=data.data[0].children[x].text
                                    }
                                }
                            }
                        }
                    }

                })
            },
            setValue(val,num){
                if(this.province!=''&&num==1){
                    this.city='';
                    this.cityTpye=false;
                    this.cityList=[];
                    this.district='';
                    this.districtTpye=false;
                    this.districtList=[];
                }else if(this.city!=''&&num==2){
                    this.district='';
                    this.districtTpye=false;
                    this.districtList=[];
                }
                this.id=val;
                this.getAdd(this.id)

            }
        },
        created(){
            console.log('hhhhhhhhhhhhhhhhhhhhhh',this.text)
            console.log('gggggggggggggggggggg',this.isShowText)
            console.log('123',this.props)
        },
        mounted () {
            this.getAdd(' ')
        },
        watch:{
            id(v){
                console.log(v)
                this.$emit('update:lcy',v)
            },
            lcy(v){
                this.id=v
            },
            text(v){
                console.log('gggggggggggggggggggg',v)
                this.isShowText=(v==true?true:false)

            }
        }
    };
</script>
<style lang="scss" scoped>
    .mySelect{
        width: 100%;
        display: flex;
        justify-content: space-between;
        /deep/ .el-select{
            width: 32%!important;
            input[readonly='readonly']{
                background: #fff;
            }
            input[disabled='disabled']{
                background: #f1f1f1;
            }
            .el-input{
                width: 100%!important;
            }
        }
    }
</style>